import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Container from "@mui/material/Container";
import LinkList from "./LinkList";

const pages = [
  { title: "Terms of Service", path: "/terms-of-service" },
  { title: "Privacy Policy", path: "/privacy-policy" },
];

const Navbar = () => {
  return (
    <AppBar
      position="static"
      sx={{ marginTop: "auto", backgroundColor: "white", boxShadow: "none" }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Box
            sx={{
              width: { xs: "70%" },
              display: { xs: "flex", md: "flex" },
              justifyContent: { md: "center", xs: "space-around" },
              color: "white",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            {pages.map((page, i) => {
              return <LinkList key={i} textColor={"black"} page={page} />;
            })}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};
export default Navbar;
